/**
 * @generated SignedSource<<08f6f2f6dbdd3468b491ee183b04dc15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PieceRendererViewAttributes_note$data = {
  readonly note_id: string;
  readonly bulb_id: string;
  readonly midi_number: number;
  readonly pitch_name: string;
  readonly left_handed: boolean;
  readonly note_start: number;
  readonly " $fragmentType": "PieceRendererViewAttributes_note";
};
export type PieceRendererViewAttributes_note$key = {
  readonly " $data"?: PieceRendererViewAttributes_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"PieceRendererViewAttributes_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PieceRendererViewAttributes_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "note_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bulb_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "midi_number",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pitch_name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "left_handed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "note_start",
      "storageKey": null
    }
  ],
  "type": "MusicPieceFileNote",
  "abstractKey": null
};

(node as any).hash = "f10c5c41c8212998264559111552211e";

export default node;
